import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentsMeasuresAPI, RegisterComponentMeasures } from './componentsMeasures'
import {
	ComponentsMeasuresAPISymbol,
	GroupMeasuresSymbol,
	FiveGridLineMeasuresSymbol,
	RegisterComponentsMeasureSymbol,
	PageChildMeasuresSymbol,
	MediaContainerChildMeasuresSymbol,
} from './symbols'
import type { IComponentsMeasuresAPI, IGroupMeasures, RegisterComponentMeasuresAPI } from './types'
import { GroupMeasures } from './GroupMeasures'
import { FiveGridLineMeasures } from './FiveGridLineMeasures'
import { ComponentWillMountSymbol } from 'feature-components'
import { PageChildMeasures } from './PageChildMeasures'
import { MediaContainerChildMeasures } from './MediaContainerChildMeasures'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ComponentsMeasuresAPISymbol).to(ComponentsMeasuresAPI)
	bind(GroupMeasuresSymbol).to(GroupMeasures)
	bind(FiveGridLineMeasuresSymbol).to(FiveGridLineMeasures)
	bind(RegisterComponentsMeasureSymbol).to(RegisterComponentMeasures)
	bind(PageChildMeasuresSymbol).to(PageChildMeasures)
	bind(MediaContainerChildMeasuresSymbol).to(MediaContainerChildMeasures)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(RegisterComponentMeasures)
}

// Public Symbols
export { ComponentsMeasuresAPISymbol, GroupMeasuresSymbol, RegisterComponentsMeasureSymbol }

// Public Types
export type { IComponentsMeasuresAPI, IGroupMeasures, RegisterComponentMeasuresAPI }
